<form *ngIf='form as form' [formGroup]='form' autocomplete='off' novalidate>
  <fieldset>
    <div class='row'>
      <div class='col-12'>
        <legend>{{ label }}</legend>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-0 mt-3">
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameTrue" [value]="true">
            <label for="provideRoadNumberAndNameTrue">
              Chcę wprowadzić numer i nazwę drogi
            </label>
          </div>
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameFalse" [value]="false">
            <label for="provideRoadNumberAndNameFalse">
              Chcę wprowadzić ulicę
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            (change)="form.cityChange()"
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @if (form.provideRoadNumberAndName.value) {
              @for (item of townWithRoadsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            } @else {
              @for (item of townWithStreetsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.roadNumber) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>
              Numer drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="roadNumberChange(form.getElement($event).value)"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getRoadList(form.city.value); track $index) {
                <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadName) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"roadName" as controlName'>
            <label [for]='controlName'>
              Nazwa drogi *
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę drogi'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.street) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getStreetList(form.city.value); track $index) {
                <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                </option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
  </fieldset>
  <div class="row">
    <div class="col-12">
      <div class="form-group mb-0 mt-3">
        <div class="custom-radio custom-inline">
          <input name="devicesProvidePlacementDeadline"
                 (change)="form.devicesProvidePlacementDeadlineChange(false)"
                 formControlName="devicesProvidePlacementDeadline"
                 type="radio"
                 id="devicesProvidePlacementDeadlineFalse"
                 [value]="false">
          <label for="devicesProvidePlacementDeadlineFalse">
            Chcę podać termin umieszczenia urządzenia wyłącznie w bieżącym roku
          </label>
        </div>
        <div class="custom-radio custom-inline">
          <input name="devicesProvidePlacementDeadline"
                 (change)="form.devicesProvidePlacementDeadlineChange(true)"
                 formControlName="devicesProvidePlacementDeadline"
                 type="radio"
                 id="devicesProvidePlacementDeadlineTrue"
                 [value]="true">
          <label for="devicesProvidePlacementDeadlineTrue">
            Chcę podać termin umieszczenia urządzenia również w kolejnych latach
          </label>
        </div>
      </div>
    </div>
  </div>
  <br>
  <fieldset>
    <legend>
      Termin umieszczenia urządzenia w bieżącym roku
    </legend>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"startDate" as controlName'>
          <label [for]='controlName'>
            Data od *
          </label>
          <app-date-picker (change)="form.startDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"endDate" as controlName'>
          <label [for]='controlName'>
            Data do *
          </label>
          <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"dayQuantity" as controlName'>
          <label [for]='controlName'>
            Ilość dni
          </label>
          <input
            readonly
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Ilość dni'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
  @if (!!form.nextYearsDateFrom && !!form.nextYearsDateTo && !!form.yearsCount) {
    <br>
    <fieldset>
      <legend>
        Termin umieszczenia urządzenia w kolejnych latach
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"nextYearsDateFrom" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker
              mode="month"
              (change)="form.calcYearsCount()"
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group'
               *ngIf='"nextYearsDateTo" as controlName'>
            <label [for]='controlName'>
              Data do *
            </label>
            <app-date-picker
              mode="month"
              (change)="form.calcYearsCount()"
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors
              fieldLabel='Data od'
              secondFieldLabel='dacie do'
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class='form-group' *ngIf='"yearsCount" as controlName'>
            <label [for]='controlName'>
              Ilość lat
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Ilość lat'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  }
  <br>
  <fieldset>
    <legend>
      Działki
    </legend>
    <div class="row">
      <div class="col-12">
        <app-parcels-crud formControlName="parcels"></app-parcels-crud>
      </div>
    </div>
  </fieldset>
  <br>
  <fieldset>
    <legend>
      Powierzchnia rzutu poziomego
    </legend>
    <div class="row">
      <div class="col-12">
        <app-alert alertTitle="Uwaga!" type="info" [closable]="false">
          Wypełnij min <strong>1</strong> z poniższych pól.
        </app-alert>
      </div>
    </div>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"devicesCountyRoadsArea" as controlName'>
          <label [for]='controlName'>
            <br>
            Powierzchnia w ciągu dróg powiatowych (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"devicesOnBridgeArea" as controlName'>
          <label [for]='controlName'>
            <br>
            Powierzchnia na obiekcie mostowym (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"infrastructureEquipmentArea" as controlName'>
          <label [for]='controlName'>
            Obiektów i urządzeń infrastruktury <br> telekomunikacyjnej (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
</form>
